import { normalizeDateFromApi } from 'helpers/datetimeHelpers';
import { Proposal } from './proposals.types';

export function normalizeApiResponse(data: Proposal): Proposal {
  if (!data.productSnapshot?.timedSegments) {
    return data;
  }
  const segments = data.productSnapshot?.timedSegments.map(segment => ({
    ...segment,
    startDate: normalizeDateFromApi(segment.startDate),
    endDate: segment.endDate ? normalizeDateFromApi(segment.endDate) : null,
  }));
  return {
    ...data,
    productSnapshot: { ...data.productSnapshot, timedSegments: segments },
  };
}
